module.exports = __webpack_public_path__ + "static/media/2020040415433400-02CB906EA538A35643C1E1484C4B947D.5d2de127.jpg";